module.exports = __webpack_public_path__ + "static/media/logo.84983718.png";